import { render, staticRenderFns } from "./PinnedAwardsBtn.vue?vue&type=template&id=644d6fb2"
import script from "./PinnedAwardsBtn.vue?vue&type=script&lang=js"
export * from "./PinnedAwardsBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports